import { useTranslation } from "react-i18next";

import type { CoaAction, CoaStatus } from "@/api/diagnostic-chart-of-accounts";

/**
 * Os nomes dos status (EF-FUNC-009 §5.2) e das ações (§6) do plano de contas.
 *
 * Um mapa por chamada literal de tradução, e não um mapa indexado: a trava de i18n
 * só enxerga a chamada de tradução com texto fixo.
 */
export function useCoaStatusLabels(): Record<CoaStatus, string> {
  const { t } = useTranslation();
  return {
    A: t("Direct equivalent"),
    B: t("Equivalent with adjustment"),
    C: t("Create account"),
    D: t("Do not migrate"),
  };
}

export function useCoaActionLabels(): Record<CoaAction, string> {
  const { t } = useTranslation();
  return {
    keep: t("Keep"),
    renumber: t("Renumber"),
    create_mirror: t("Create mirror"),
    remove: t("Remove"),
  };
}
